import React from "react"
import IconFont from "./IconFont"
import type { PrismancyIconId } from "../../icons/icon-font/generated/prismancy-icons"

export type VariableDotStatus = "live" | "draft" | "ended"

const variableDotIcons: Record<VariableDotStatus, PrismancyIconId> = {
    live: "live-dot",
    draft: "draft-dot",
    ended: "ended-dot",
}

const variableDotColorClasses: Record<VariableDotStatus, string> = {
    live: "pi-status-dot-live",
    draft: "pi-status-dot-draft",
    ended: "pi-status-dot-ended",
}

interface VariableDotProps {
    status: VariableDotStatus
    className?: string
    id?: string
}

const VariableDot: React.FC<VariableDotProps>= ({ status, className = "", id }) => {
    return (
        <span id={id} className={`inline-flex ${className}`.trim()}>
            <IconFont
                name={variableDotIcons[status]}
                size={12}
                className={`pi-status-dot ${variableDotColorClasses[status]}`}
            />
        </span>
    )
}

export default VariableDot
